import React, { useCallback, useEffect, useRef, useState } from 'react'

import { Card } from './Card'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import plus from "../../svgs/plus-white.svg";
import Icon from '../Icon/Icon'
import { uploadFile } from '../../requests/fileRequests';
import { existingFileError, existingFileErrorMessage } from '../../consts/consts';
import ConfirmationDialog from '../ConfirmDialog';
const style = {
  width: 1600,
  display: 'grid',
  gridTemplateColumns: '266.66px 266.66px 266.66px 266.66px 266.66px 266.66px',
  gap: '10px'
}

const DragableCard = (props) => {
    const fileInputRef = useRef();
    const [cards, setCards] = useState(props.data)
    const [showConfirm, setShowConfirm] = useState(false)

    useEffect(() =>{setCards(props.data)},[props.data])
    const moveCard = useCallback((dragIndex, hoverIndex) => {
        if(props.viewMode){ return;}
        setCards((prevCards) => {
            // Step 1: Create a copy of the previous cards array
            const updatedCards = [...prevCards];
          
            // Step 2: Remove the card from the dragIndex
            const [removedCard] = updatedCards.splice(dragIndex, 1);
          
            // Step 3: Insert the removed card at the hoverIndex
            updatedCards.splice(hoverIndex, 0, removedCard);
          
            // Step 4: Return the updated array
            props.handleChangeFile(updatedCards, props.index);
            return updatedCards;
          });
    }, [props.viewMode, props.type])

    const renderCard = useCallback(
      (card, index) => {
        return (
          <Card
            key={index}
            index={index}
            card={card}
            moveCard={moveCard}
            remove={onRemove}
            viewMode={props.viewMode}
            type={props.type}
          />
        )
      },
      [props.viewMode, props.type],
    )


    const getBase64 = (file) => {
        return new Promise(resolve => {
            let baseURL = "";
            let reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }
    const generateRandomString = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length: 5 }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
      };

    const upload = (file, _fileName) => {
        const fileName = _fileName? _fileName : file.name;
        const base64File = file.base64;
        return uploadFile({fileName, base64File, folder:'pricing_analysis'}).then(res => {
            fileInputRef.current.value = null;
            res = res.data.uploadImage;
            if (!res || !res.success) {
                if (res.message === 'Unable to upload file, one with this path/name already exists') {
                    const tempFileName = generateRandomString() + file.name;
                    upload(file, tempFileName);
                } else {
                    props.setState({error:res && res.message ? res.message : "Unspecified error"})
                }
            } else {
                const newCards = [...cards, {name: fileName, link:res.fileUrl.fileUrl}]
                props.handleChangeFile(newCards, props.index);
                setCards(newCards);
            }
        })
    }

    const remove = (card) => {
        fileInputRef.current.value = null;
        props.handleChangeFile(cards.filter(_card => _card.link!== card.link), props.index);
        setCards(cards.filter(_card => _card.url!== card.link));
        props.setState((prevState)=>({error:null, removedCard:prevState.removedCards.push(card)}));
        setShowConfirm(false);
    }

    const validateSelectedFile = (event) => {
        let selectedFile = event.currentTarget.files[0];
        const fileSize = selectedFile.size / 1000000; //mb

        if (fileSize > 20){
            props.setState({error:'Maximum file size exceeded'})
            return;
        }
        
        getBase64(selectedFile).then(result => {
            selectedFile["base64"] = result;
            upload(selectedFile);
        });
    }
    const onRemove = (card) => {
        setShowConfirm(card);
    }
    const onCloseConfirm = (val) => {
        if(val){
            remove(showConfirm);
        }else{
            setShowConfirm(false);
        }
    }
    return (
    <React.Fragment>
    <ConfirmationDialog open={showConfirm}  onClose={onCloseConfirm} content="Permanently delete selected file?" />
        <DndProvider backend={HTML5Backend}>
            <div style={style}>
            {cards.map((card, i) => renderCard(card, i))}
            <div className={`add-new-button ${props.viewMode&&'add-new-button-card-disabled'}`} onClick={(e)=>{if(!props.viewMode){fileInputRef.current.click()}}}>
                <div className={`button-new plus ${!props.viewMode?'positive': 'add-new-button-disabled'}`}>
                    <Icon svg={plus}/>
                </div>
            </div>
            </div>
		</DndProvider>
        <input className='hidden' type="file" ref={fileInputRef} accept={"image/png, image/jpeg, image/jpg, .svg"} onChange={validateSelectedFile} />
    </React.Fragment>
    )
}
export default DragableCard;